import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AppLayout from "./layout/AppLayout";
Vue.use(Router)

export default new Router({
  mode: "history",
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/dashboard',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard.vue'),meta:{
            auth: {
              roles: ["retailer","wholesaler","admin","rider"]
            }
          }
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "demo" */ './views/UserProfile.vue'),meta:{
            auth: {
              roles: ["retailer","wholesaler","admin","rider"],
            }
          }
        },
        {
          path: '/maps',
          name: 'maps',
          component: () => import(/* webpackChunkName: "demo" */ './views/Maps.vue')
        },
        {
          path: '/tables',
          name: 'tables',
          component: () => import(/* webpackChunkName: "demo" */ './views/Tables.vue')
        },
        {
          path: '/allProducts/:uniqueId',
          name: 'Product Details',
          component: () => import(/* webpackChunkName: "demo" */ './views/ProductDetails.vue'),meta:{
            auth: {
              roles:"admin",
            }
          }
        },
        {
          path: '/addProducts',
          name: 'Add Products',
          component: () => import(/* webpackChunkName: "demo" */ './views/AddProducts.vue'),meta:{
            auth: {
              roles: ["retailer","wholesaler","admin","rider"]
            }
          }
        },
          {
              path: '/ShoppingOrders',
              name: 'shopping orders',
              component: () => import(/* webpackChunkName: "demo" */ './views/ShoppingOrders.vue'),meta:{
                  auth: {
                      roles:"admin",
                  }
              }
          },
        {
          path: '/shoppingOrderInfo/:orderNo',
          name: 'shoppingOrderInfo',

          component: () => import(/* webpackChunkName: "demo" */ './views/ShoppingOrderInfo.vue'),meta:{
            auth: {
              roles:"admin",
            }
          }
        },
        {
          path: '/allProducts',
          name: 'All Products',
          component: () => import(/* webpackChunkName: "demo" */ './views/AllProducts.vue'),meta:{
            auth: {
              roles:"admin",
            }
          }
        },
        {
          path: '/coupons',
          name: 'coupons',
          component: () => import(/* webpackChunkName: "demo" */ './views/Coupons.vue'),meta:{
            auth: {
              roles:"admin",
            }
          }
        },
        {
          path: '/systemLog',
          name: 'system Logs',
          component: () => import(/* webpackChunkName: "demo" */ './views/systemLog.vue'),meta:{
            auth: {
              roles:"admin",
            }
          }
        },
        {
          path: '/userManagement',
          name: 'UserManager',

          component: () => import(/* webpackChunkName: "demo" */ './views/UserManager.vue'),meta:{
            auth: {
              roles:"admin",
            }
          }
        },
        {
          path: '/userDetails/:id',
          name: 'userDetails',

          component: () => import(/* webpackChunkName: "demo" */ './views/userDetails.vue'),meta:{
            auth: {
              roles:"admin",
            }
          }
        },
        {
          path: '/categories',
          name: 'categories',
          component: () => import(/* webpackChunkName: "demo" */ './views/Categories.vue'), meta:{
            auth: {
              roles:"admin",
            }
          }
        },
        {
          path: '/addMyProducts',
          name: 'Add my Products',
          component: () => import(/* webpackChunkName: "demo" */ './views/RetailerWholesaler/AddMyProducts'),meta:{
            auth: {
              roles:["retailer","wholesaler"],
            }
          }
        },
        {
          path: '/allMyProducts',
          name: 'All My Products',
          component: () => import(/* webpackChunkName: "demo" */ './views/RetailerWholesaler/AllMyProducts'),meta:{
            auth: {
              roles:["retailer","wholesaler"],
            }
          }
        },
        {
          path: '/allMyProducts/:uniqueId',
          name: 'My Product Details',
          component: () => import(/* webpackChunkName: "demo" */ './views/RetailerWholesaler/MyProductDetails'),meta:{
            auth: {
              roles:["retailer","wholesaler"],
            }
          }
        },
        {
          path: '/MyShoppingOrders',
          name: 'my shopping orders',
          component: () => import(/* webpackChunkName: "demo" */ './views/RetailerWholesaler/ShoppingOrders'),meta:{
            auth: {
              roles:["retailer","wholesaler"],
            }
          }
        },
        {
          path: '/MyshoppingOrderInfo/:id',
          name: 'MyshoppingOrderInfo',

          component: () => import(/* webpackChunkName: "demo" */ './views/RetailerWholesaler/MyShoppingOrderInfo'),meta:{
            auth: {
              roles:["retailer","wholesaler"],
            }
          }
        },
          //Rider
        {
          path: '/Delivery',
          name: 'Shipping Orders',

          component: () => import(/* webpackChunkName: "demo" */ './views/Rider/Delivery'),meta:{
            auth: {
              roles:"rider",
            }
          }
        },
        {
          path: '/shippingOrderInfo/:orderNo',
          name: 'Shipping Order info',

          component: () => import(/* webpackChunkName: "demo" */ './views/Rider/ShippingOrderInfo'),meta:{
            auth: {
              roles:"rider",
            }
          }
        },
      ]
    },
    {
      path: '/',
      redirect: '/',
      component: AppLayout,
      children: [
        {
          path: '/',
          name: 'index',
          component: () => import(/* webpackChunkName: "demo" */ './views/customer/index.vue')
        },
        {
          path: '/register',
          name: 'register',
          component: () => import(/* webpackChunkName: "demo" */ './views/auth/Register.vue'), meta:{
            auth: false
          }
        },
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "demo" */ './views/auth/Login.vue'), meta:{
            auth: false
          }
        },
        {
          path: '/notVerified/:email',
          name: 'notVerified',
          component: () => import('./views/Errors/NotVerified.vue'), meta:{
            auth: false
          }
        },
          {
              path: '/reset-password',
              name: 'reset-password',
              component: () => import(/* webpackChunkName: "demo" */ './views/auth/ForgotPassword.vue'), meta:{
                  auth: false
              }
          },
          {
              path: '/reset-password/:token',
              name: 'reset-password-form',
              component: () => import(/* webpackChunkName: "demo" */ './views/auth/ResetPassword.vue'), meta:{
                  auth: false
              }
          },
        {
          path: '/email/verify/:id/:hash',
          name: 'verify',
          component: () => import(/* webpackChunkName: "demo" */ './views/auth/verify.vue'), meta:{
            auth: undefined
          }
        },
        {
          path: '/customer/profile',
          name: 'customer.profile',
          component: () => import(/* webpackChunkName: "demo" */ './views/customer/Profile'), meta:{
            auth: {
              roles: "customer",
            }
          }
        },
        {
          path: '/shops',
          name: 'shops',
          component: () => import(/* webpackChunkName: "demo" */ './views/customer/Shops')
        },
        {
          path: '/all-categories',
          name: 'products.categories',
          component: () => import(/* webpackChunkName: "demo" */ './views/customer/Categories')
        },
        {
          path: '/categories/:categoryId/:categoryName',
          name: 'products.category',
          component: () => import(/* webpackChunkName: "demo" */ './views/customer/CategoryProducts')
        },
        {
          path: '/category/:category/:productId',
          name: 'product_details',
          component: () => import(/* webpackChunkName: "demo" */ './views/customer/ProductDetails')
        },
        {
          path: '/cart',
          name: 'cart',
          component: () => import(/* webpackChunkName: "demo" */ './views/customer/Cart')
        },
        {
          path: '/my-orders',
          name: 'my-orders',
          component: () => import(/* webpackChunkName: "demo" */ './views/customer/MyOrders'), meta:{
            auth: true
          }
        },
        {
          path: '/my-orders/:orderNo',
          name: 'my-order-details',
          component: () => import(/* webpackChunkName: "demo" */ './views/customer/MyOrderDetails'), meta:{
            auth: true
          }
        },
        {
          path: '/about-us',
          name: 'about',
          component: () => import(/* webpackChunkName: "demo" */ './views/customer/AboutUs')
        },
        {
          path: '/contact-us',
          name: 'contact',
          component: () => import(/* webpackChunkName: "demo" */ './views/customer/ContactUs')
        },


        {
          // catch all 404 - define at the very end
          path: "*",
          component: () => import("./views/Errors/NotFound.vue")
        }
      ]
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  }

})
